// extracted by mini-css-extract-plugin
export default {"container":"TwoImages_container__wMFmV","heading":"TwoImages_heading__HYhJ7","subHeading":"TwoImages_subHeading__BOSOK","lmb":"TwoImages_lmb__UUiU8","img":"TwoImages_img__ew5d3"};